// extracted by mini-css-extract-plugin
export var body = "_oq-8";
export var button = "_oq-0";
export var closeButton = "_oq-5";
export var content = "_oq-3";
export var empty = "_oq-f";
export var grid = "_oq-c";
export var header = "_oq-4";
export var icon = "_oq-1";
export var option = "_oq-d";
export var optionSelected = "_oq-e";
export var overlay = "_oq-2";
export var searchIcon = "_oq-a";
export var searchInput = "_oq-b";
export var searchWrapper = "_oq-9";
export var title = "_oq-6";
export var visuallyHidden = "_oq-7";